/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Step3_TitleInputs */

const en_landing_how_step3_title = /** @type {(inputs: Landing_How_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply and track`)
};

const de_landing_how_step3_title = /** @type {(inputs: Landing_How_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerben und verfolgen`)
};

const fr_landing_how_step3_title = /** @type {(inputs: Landing_How_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postule et suis`)
};

const es_landing_how_step3_title = /** @type {(inputs: Landing_How_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicita y haz seguimiento`)
};

const it_landing_how_step3_title = /** @type {(inputs: Landing_How_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidati e monitora`)
};

const nl_landing_how_step3_title = /** @type {(inputs: Landing_How_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solliciteer en volg`)
};

const pl_landing_how_step3_title = /** @type {(inputs: Landing_How_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikuj i śledź`)
};

const fi_landing_how_step3_title = /** @type {(inputs: Landing_How_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae ja seuraa`)
};

const da_landing_how_step3_title = /** @type {(inputs: Landing_How_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøg og følg op`)
};

const sv_landing_how_step3_title = /** @type {(inputs: Landing_How_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansök och följ upp`)
};

/**
* | output |
* | --- |
* | "Apply and track" |
*
* @param {Landing_How_Step3_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_how_step3_title = /** @type {((inputs?: Landing_How_Step3_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Step3_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_how_step3_title(inputs)
	if (locale === "fr") return fr_landing_how_step3_title(inputs)
	if (locale === "es") return es_landing_how_step3_title(inputs)
	if (locale === "it") return it_landing_how_step3_title(inputs)
	if (locale === "nl") return nl_landing_how_step3_title(inputs)
	if (locale === "pl") return pl_landing_how_step3_title(inputs)
	if (locale === "fi") return fi_landing_how_step3_title(inputs)
	if (locale === "da") return da_landing_how_step3_title(inputs)
	if (locale === "sv") return sv_landing_how_step3_title(inputs)
	return en_landing_how_step3_title(inputs)
});